import { render, staticRenderFns } from "./insInfoSearch.vue?vue&type=template&id=2b4910c8&scoped=true&"
import script from "./insInfoSearch.vue?vue&type=script&lang=js&"
export * from "./insInfoSearch.vue?vue&type=script&lang=js&"
import style0 from "./insInfoSearch.vue?vue&type=style&index=0&id=2b4910c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4910c8",
  null
  
)

export default component.exports